export const STOP = new Set([
  'torta','tortas','torteria','tortería','ramen','noodles','comida','food','cdmx','mexico','méxico','restaurante','los','las','el','la','de','del','y','en'
]);

export const deburr = (s: string) => (s || '')
  .normalize('NFD')
  .replace(/\p{Diacritic}/gu, '')
  .toLowerCase();

export const toks = (s: string) => deburr(s)
  .split(/[^a-z0-9]+/)
  .filter(t => t.length >= 3 && !STOP.has(t));

export function brandHits(ocrTokens: string[], candidateName: string) {
  const nameSet = new Set(toks(candidateName));
  const hits = (ocrTokens || []).map(deburr).filter(t => nameSet.has(t));
  return Array.from(new Set(hits));
}
